import { render, staticRenderFns } from "./StatisticTableViewIconsItem.vue?vue&type=template&id=1d47ea41&scoped=true"
import script from "./StatisticTableViewIconsItem.vue?vue&type=script&lang=js"
export * from "./StatisticTableViewIconsItem.vue?vue&type=script&lang=js"
import style0 from "./StatisticTableViewIconsItem.vue?vue&type=style&index=0&id=1d47ea41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47ea41",
  null
  
)

export default component.exports